'use client';

import Link from 'next/link';

export function MicPrePrompt({ onAccept, onCancel }: { onAccept: () => void; onCancel: () => void }) {
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-surface/90 backdrop-blur-md px-6">
      <div className="w-full max-w-md border border-outline-variant bg-surface-container-low p-8">
        <p className="font-mono text-[10px] tracking-widest text-primary mb-6">
          SYSTEM // AUTHORIZATION REQUIRED
        </p>
        <h2 className="text-xl font-semibold text-on-surface tracking-tight mb-4">
          Before we connect
        </h2>
        <p className="text-sm leading-relaxed text-on-surface-variant mb-3">
          Just Ask Satoshi listens through your microphone and replies with synthesised speech.
          Your audio is sent to ElevenLabs for transcription and response. Raw audio is not stored.
        </p>
        <p className="text-sm leading-relaxed text-on-surface-variant mb-3">
          Transcripts are kept for 30 days for debugging, then purged.
        </p>
        <p className="text-sm leading-relaxed text-on-surface-variant mb-8">
          You have a{' '}
          <span className="text-primary font-medium">5-minute</span> conversation budget per 24
          hours.
        </p>
        <p className="font-mono text-[10px] tracking-wide text-outline mb-8">
          Full details in the{' '}
          <Link href="/privacy" className="text-primary hover:underline underline-offset-2">
            privacy notice
          </Link>{' '}
          and{' '}
          <Link href="/terms" className="text-primary hover:underline underline-offset-2">
            terms
          </Link>
          .
        </p>
        <div className="flex gap-3">
          <button
            onClick={onAccept}
            className="flex-1 bg-primary-bright text-on-primary font-mono text-xs font-bold tracking-widest px-4 py-3 hover:bg-primary transition-colors"
          >
            GRANT ACCESS
          </button>
          <button
            onClick={onCancel}
            className="border border-outline-variant text-on-surface-variant font-mono text-xs tracking-widest px-4 py-3 hover:border-outline hover:text-on-surface transition-colors"
          >
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );
}
